/* eslint no-multi-spaces: 'off', eqeqeq: 'off' */

import current from '@/scripts/current'
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';

// initial state
// shape: [{ id, quantity }]
const state = {
    analysisType: null,
    isReadyForNextStep: false,
    variables: {},
    userNeedsHelp: false,
    executionStats: { records: 0, seconds: 0 },
    locations: {
        isSet: false,
        all: false,
        names: [],
        ids: [],    //ids to display (use 0 for all)
        allNames: [],
        allIds: [], //individual state ids, more then 50 of these if 'all' selected
        selectionType: 'single'
    },
    years: {
        single: 0,                  //store.state.selModel.years.single
        values: [],                 //store.state.selModel.years.values
        selectionType: 'single',    //store.state.selModel.years.selectionType
        asList: '',                 //store.state.selModel.years.asList
        display: ''                 //store.state.selModel.years.display
    },
    storeSelectionModel: null

}

//store.state.selModel.years.selectionType

// getters
const getters = {
    displayData: (state, getters) => {
        return { isReadyForNextStep: state.isReadyForNextStep };
    },
    getExecutionStats: (state, getters) => {
        return state.executionStats;
    },
    getUserNeedsHelp: state => state.userNeedsHelp
}
function getLocationNotSet() {
    return {
        isSet: false,
        all: false,
        ids: [],
        names: [],
        allIds: [],
        allNames: [],
        selectionType: null
    }
}

function getSortedLocations(locations) {
    return locations.slice().sort((a, b) => a.stateId - b.stateId);
}

function getLocationForAll(selectionType, sortedAllLocations) {
    return {
        isSet: true,
        all: true,
        ids: ['0'],
        names: ['All'],
        allIds: sortedAllLocations.map(l => l.stateId),
        allNames: sortedAllLocations.map(l => l.state),
        selectionType: selectionType
    }
}

function getLocationList(locationIds, selectionType, sortedAllLocations) {
    const selectedIds = Object.assign(...locationIds.map(l => ({ [l]: true })));
    const selectedLocations = sortedAllLocations.filter(l => selectedIds[l.stateId]);

    const ids = selectedLocations.map(l => l.stateId);
    const names = selectedLocations.map(l => l.state);
    const isSet = selectionType === 'single' ? ids.length === 1 : ids.length > 1;
    return {
        isSet: isSet,
        all: false,
        ids: ids,
        names: names,
        allIds: ids,
        allNames: names,
        selectionType: selectionType
    }
}

function getLocations(selectionType, locationIds) {
    const sortedAllLocations = getSortedLocations(commonModelHelper.groupLocations());
    if (locationIds.length === 0)
        return getLocationNotSet();
    switch (selectionType) {
        case 'single':
            if (locationIds[0] == 0)
                return getLocationForAll(selectionType, sortedAllLocations);
            else
                return getLocationList(locationIds, selectionType, sortedAllLocations);
        case 'combine':
        case 'compare':
            if (locationIds.length === sortedAllLocations.length)
                return getLocationForAll(selectionType, sortedAllLocations);
            else {
                return getLocationList(locationIds, selectionType, sortedAllLocations);
            }
        default:
            return getLocationNotSet();
    }
}

function getIsReadyForNextStep() {
    if (!current.modelHelper)
        return false;
    var stack = new Error().stack;
    //console.log('PRINTING CALL STACK');
    //console.log(stack);
    current.modelHelper.makeModelValid();
    return current.modelHelper.isValid[current.selectionModel.currentStep](current.selectionModel);
}

function setAnalysis(commit, analysisType, years, locations) {
    var storeSelectionModel = JSON.parse(JSON.stringify({ years, locations })); //make a copy
    commit('setTheAnalysis', { analysisType, storeSelectionModel });
}

function setTheYears(commit, state, selectedYears) {
    if (!selectedYears || selectedYears.length === 0)
        commit('setYears', {
            single: 0,
            values: [],
            selectionType: state.years.selectionType,
            asList: ''
        });
    else
        commit('setYears', {
            single: selectedYears[0],
            values: selectedYears.map(y => y),  //make a copy of the array
            selectionType: state.years.selectionType,
            asList: selectedYears.join(", ")
        });
    commit('setIsReadyForNextStep', getIsReadyForNextStep());
}

function toList(value) {
    if (!value || value === 0)
        return [];
    else
        return [value];
}

// actions
const actions = {
    startCtAnalysis({ commit, state }) {
        setAnalysis(commit, 'ct', state.years, state.locations);
    },
    startLrAnalysis({ commit, state }) {
        setAnalysis(commit, 'lr', state.years, state.locations);
    },
    restoreSelectionModel({ commit, state }, { storeSelectionModel }) {
        commit('setYears', storeSelectionModel.years);
        commit('setLocations', storeSelectionModel.locations);
    },
    setYear({ commit, state }, { selectedYear }) {
        setTheYears(commit, state, toList(selectedYear));
    },
    setYears({ commit, state }, { selectedYears }) {
        setTheYears(commit, state, selectedYears);
    },
    setYearSelectionType({ commit, state }, { selectionType }) {
        //debugger
        commit('setYears', {
            single: 0,
            values: [],
            selectionType,
            asList: ''
        });
        commit('setIsReadyForNextStep', getIsReadyForNextStep());
    },
    setLocations({ commit, state }, { selectionType, locationIds }) {
        const locations = getLocations(selectionType, locationIds);
        //console.log('!!!setLocations ${locations.allNames.join(', ')}`)
        commit('setLocations', locations);
    },
    setReadyForNextStep({ commit, state }) {
        commit('setIsReadyForNextStep', getIsReadyForNextStep());
        actions.setExecutionStats({ commit, state });
    },
    setExecutionStats({ commit, state }) {
        var years = state.years.values;
        var locations = state.locations.ids;
        const stateYearCounts = store.state.dataLists.stateYearCounts;
        var counts = stateYearCounts.filter(c => (!state.locations.isSet || state.locations.all || state.locations.ids.indexOf(c.State) >= 0) && years.indexOf(c.Year) >= 0);
        var selectedRecordCount = 0;
        counts.forEach(c => selectedRecordCount += c.NumberOfRecords);
        var seconds = current.modelHelper.getLoadTime(selectedRecordCount);
        commit('setExecutionStats', { records: selectedRecordCount, seconds: seconds });
    },
    setVariable({ commit }, { variableType, variable }) {
        var variables = {};
        if (current.currentType === 'ct') {
            variables = {
                row: state.row,
                column: state.column,
                control1: state.control1,
                control2: state.control2
            }
        } else if (current.currentType === 'lr') {
            variables = {
                dependent: state.dependent,
                independent: state.independent
            }
        };
        variables[variableType] = variable;
        commit('setVariables', variables);
    },
    setUserNeedsHelp({ commit }) {
        commit('setUserNeedsHelp', true);
    },
    resetUserNeedsHelp({ commit }) {
        commit('setUserNeedsHelp', false);
    }
}

// mutations
const mutations = {
    setIsReadyForNextStep(state, isReadyForNextStep) {
        state.isReadyForNextStep = isReadyForNextStep
    },
    setVariables(state, variables) {
        state.variables = variables
    },
    setUserNeedsHelp(state, userNeedsHelp) {
        state.userNeedsHelp = userNeedsHelp
    },
    setExecutionStats(state, stats) {
        state.executionStats = stats;
    },
    setLocations(state, { isSet, all, names, ids, allNames, allIds, selectionType }) {
        state.locations.isSet = isSet;
        state.locations.all = all;
        state.locations.names = copy(names);
        state.locations.ids = copy(ids);
        state.locations.allNames = copy(allNames);
        state.locations.allIds = copy(allIds);
        state.locations.selectionType = selectionType;
    },
    setYears(state, { single, values, selectionType, asList, isReadyForNextStep }) {
        state.years.single = single;
        state.years.values = copy(values);
        state.years.selectionType = selectionType;
        state.years.asList = asList;
        state.years.display = values.length > 0 ? `${asList} (${selectionType})` : '';
        state.isReadyForNextStep = isReadyForNextStep;

    },
    setTheAnalysis(state, { analysisType, storeSelectionModel }) {
        state.analysisType = analysisType;
        state.storeSelectionModel = storeSelectionModel;
    }
}

function copy(values) {
    if (values == undefined || values == null)
        return null;
    return values.map(v => v);

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
